/* eslint-disable import/namespace */
import { configureStore } from '@reduxjs/toolkit';
import {
  getgwaManageList,
  setCompaignList,
  setEPVolunteerReg,
  setIsLoadVolunteerReg,
  updateGwaRegisterList,
  updategwaprojectListSlice,
} from '../features';
import authReducer from '../features/authSlice';
import cartReducer from '../features/cartSlice';
import cartuserSlice from '../features/usercartSlice';
import togglebuttonSlice from '../features/togglebuttonSlice';
import updateCartSlice from '../features/updatedCartSlice';
import addMenuTitleSlice from '../features/MainMenuTitleSlice';
import addTitleSlice from '../features/campaignMenuSlice';
const store = configureStore({
  reducer: {
    compaignList: setCompaignList,
    gwaRegisterList: updateGwaRegisterList,
    gwaprojectList: updategwaprojectListSlice,
    gwaManageList: getgwaManageList,
    epVolunteerReg: setEPVolunteerReg,
    isLoadVolunteerReg: setIsLoadVolunteerReg,
    auth: authReducer,
    cart: cartReducer,
    usercart: cartuserSlice,
    updatedCart: updateCartSlice,
    toggle: togglebuttonSlice,
    menuTitle: addMenuTitleSlice,
    campaignMenu: addTitleSlice,
    
  },
});

export default store;
